import { render, staticRenderFns } from "./HedgeStrategy.vue?vue&type=template&id=0a3c66f9&scoped=true&"
import script from "./HedgeStrategy.vue?vue&type=script&lang=js&"
export * from "./HedgeStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c66f9",
  null
  
)

export default component.exports